(function() {
  function attach(bar) {
    var sliderId = bar.getAttribute('data-slider-id');
    var sliderSelector = bar.getAttribute('data-slider-selector');
    var hideNative = (bar.getAttribute('data-hide-native') || 'true') === 'true';
    var minThumb = parseInt(bar.getAttribute('data-min-thumb') || '24', 10);
    var slider = sliderId ? document.getElementById(sliderId) : null;
    if (!slider && sliderSelector) {
      try { slider = document.querySelector(sliderSelector); } catch(e) {}
    }
    if (!slider) {
      var prev = bar.previousElementSibling;
      if (prev) slider = prev.querySelector('.slider');
    }
    var track = bar.querySelector('.v-scrollbar__track');
    var thumb = bar.querySelector('.v-scrollbar__thumb');
    if (!track || !thumb) { return; }
    if (!slider) {
      bar.style.display = '';
      bar.classList.add('v-scrollbar--disabled');
      var trackWidthInit = track.clientWidth;
      thumb.style.width = trackWidthInit + 'px';
      thumb.style.transform = 'translateX(0px)';
      return;
    }

    if (hideNative) {
      slider.classList.add('v-scrollbar--hide-native');
    }

    var dragging = false;
    var rafPending = false;

    function update() {
      var total = slider.scrollWidth;
      var visible = slider.clientWidth;
      var maxScroll = Math.max(0, total - visible);
      var trackWidth = track.clientWidth;

      if (maxScroll <= 0) {
        bar.style.display = '';
        bar.classList.add('v-scrollbar--disabled');
        thumb.style.width = trackWidth + 'px';
        thumb.style.transform = 'translateX(0px)';
        return;
      } else {
        bar.classList.remove('v-scrollbar--disabled');
        bar.style.display = '';
      }

      var thumbWidth = Math.max(trackWidth * (visible / total), minThumb);
      var progress = (slider.scrollLeft / maxScroll);
      var maxTranslate = trackWidth - thumbWidth;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (progress * maxTranslate) + 'px)';
    }

    function onScroll() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function() { rafPending = false; update(); });
    }

    function onResize() { update(); }

    thumb.addEventListener('pointerdown', function(e) {
      dragging = true;
      if (thumb.setPointerCapture) thumb.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    window.addEventListener('pointermove', function(e) {
      if (!dragging) return;
      var rect = track.getBoundingClientRect();
      var trackWidth = rect.width;
      var total = slider.scrollWidth;
      var visible = slider.clientWidth;
      var maxScroll = Math.max(0, total - visible);
      var thumbWidth = Math.max(trackWidth * (visible / total), minThumb);
      var maxTranslate = trackWidth - thumbWidth;
      var offset = Math.max(0, Math.min(maxTranslate, e.clientX - rect.left - thumbWidth / 2));
      var progress = maxTranslate ? (offset / maxTranslate) : 0;
      slider.scrollLeft = progress * maxScroll;
      e.preventDefault();
    });

    window.addEventListener('pointerup', function() { dragging = false; });

    bar.addEventListener('pointerdown', function(e) {
      if (e.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var trackWidth = rect.width;
      var total = slider.scrollWidth;
      var visible = slider.clientWidth;
      var maxScroll = Math.max(0, total - visible);
      var thumbWidth = Math.max(trackWidth * (visible / total), minThumb);
      var maxTranslate = trackWidth - thumbWidth;
      var offset = Math.max(0, Math.min(maxTranslate, e.clientX - rect.left - thumbWidth / 2));
      var progress = maxTranslate ? (offset / maxTranslate) : 0;
      slider.scrollLeft = progress * maxScroll;
    });

    slider.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    update();
  }

  function initAll() {
    var bars = document.querySelectorAll('.v-scrollbar[data-slider-id]');
    bars.forEach(function(bar) { attach(bar); });
  }

  window.VScrollbar = {
    initAll: initAll,
    init: function(selectorOrElement) {
      if (!selectorOrElement) { initAll(); return; }
      var el = typeof selectorOrElement === 'string' ? document.querySelector(selectorOrElement) : selectorOrElement;
      if (el && el.classList && el.classList.contains('v-scrollbar')) attach(el);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }
})();